import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { UserDocument, UserDocumentCategory } from './types/UserDocument';

export default (makeCall: MakeCall) =>
  (
    userId: 'me' | number,
    docUUID: string,
    data: {
      title?: string;
      filename?: string;
      category?: UserDocumentCategory;
    },
  ) =>
    makeCall<UserDocument>(
      'PUT',
      `/api/v2/user/${userId}/document/${docUUID}`,
      {
        data,
      },
    );
